class CollectionProduct extends HTMLElement {
  constructor() {
    super();
    this.variants = this.querySelectorAll('collection-variant');
    this.variants.forEach(v => v.addEventListener('click', () => {
      this.updateFeatured(v);
      this.updateUrl(v);
    }));
  }

  updateFeatured(variant) {
    const featured = this.querySelector('collection-featured img');
    featured.src = variant.dataset.featured;
  }

  updateUrl(variant) {
    const vId = variant.dataset.url
    const links = this.querySelectorAll("a");
    links.forEach(l => l.href = `${this.dataset.url}?variant=${vId}` );
  }
}

class CollectionFeatured extends HTMLElement {
  constructor(){
    super();
  }
}

class CollectionVariant extends HTMLElement {
  constructor(){
    super();
    
  }
}

customElements.define('collection-product', CollectionProduct);
customElements.define('collection-featured', CollectionFeatured);
customElements.define('collection-variant', CollectionVariant);